module.exports = __webpack_public_path__ + "static/media/СЗФО_99.a9167a1a.png";